<template>
  <v-dialog v-model="dialog" persistent width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn small v-bind="attrs" v-on="on" :disabled="infos.disabled">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on">
              mdi-ab-testing
            </v-icon>
          </template>
          <span> {{ $t("testWebhook") }}</span>
        </v-tooltip>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dense>
        <v-toolbar-title>
          {{ $t("testWebhook") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false" :disabled="loading">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-form class="pa-4">
        <div class="d-flex justify-center mt-8" v-if="loading">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>

        <v-card-text v-if="webhookResponse.status" class="d-flex align-center">
          <v-btn
            text
            small
            class="mr-2"
            color="primary"
            @click="viewingDetails = !viewingDetails"
          >
            {{ `${viewingDetails ? $t("hide") : $t("view")} ${$t("details")}` }}
          </v-btn>

          <div
            v-if="
              webhookResponse.status >= 200 && webhookResponse.status <= 299
            "
            class="green--text"
          >
            {{ $t("success") }}
          </div>
          <div v-else class="red--text">
            {{ $t("error") }}
          </div>
        </v-card-text>

        <v-card-text v-if="webhookResponse.status && viewingDetails">
          <h3>
            {{ $t("dataBeingSent") }}
          </h3>
          <pre>
            {{ testData[infos.tipo] }}
          </pre>

          <h3 v-if="Object.keys(webhookResponse).length > 0">
            {{ $t("response") }}:
          </h3>
          <div v-if="Object.keys(webhookResponse).length > 0" class="pa-0 ma-0">
            <h4 class="my-2">
              Status:
            </h4>
            <pre>
              {{ webhookResponse.status }}
            </pre>

            <h4 class="my-2">{{ $t("datas") }}:</h4>
            <pre style="max-width: 500px; overflow: auto;">
              {{ webhookResponse.body }}
            </pre>
          </div>
        </v-card-text>
        <v-card-actions class="pt-4 px-4 mt-6 ">
          <v-spacer />
          <v-btn
            color="primary"
            @click="testWebhook"
            :loading="loading"
            :disabled="loading || infos.disabled"
          >
            {{ $t("toSend") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  props: {
    infos: {
      endpoint: { type: String },
      webhookId: { type: String },
      tipo: { type: String },
      disabled: { type: Boolean },
    },
  },

  data: () => ({
    dialog: false,
    loading: false,
    testData: {
      cadastro: {
        crm_id: 1381684,
        name: "Usuario Teste",
        email: "teste@gmail.com",
        phone: "81987654321",
        affiliate_id: 102989,
      },
      deposito: {
        value: 20,
        crm_id: 1381684,
        type_deposit: "Deposit",
        currency: "BRL",
        date: "2021-09-02 10:43:27",
        first_deposit: false,
        affiliate_id: 102989,
      },
      login: {
        crm_id: 1381684,
        date: "2021-09-02 10:43:27",
      },
    },
    webhookResponse: {},
    viewingDetails: false,
  }),

  watch: {
    dialog(val) {
      if (!val) {
        this.webhookResponse = {};
        this.viewingDetails = false;
      }
    },
  },

  methods: {
    testWebhook() {
      if (this.infos.disabled) {
        return;
      }

      this.webhookResponse = {};

      this.loading = true;

      axios
        .post(
          this.infos.endpoint,
          {
            body: this.testData[this.infos.tipo],
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.webhookResponse = {
            status: res.status,
            body: res.data,
          };
        })
        .catch((err) => {
          if (err.response && err.response.status) {
            this.webhookResponse = {
              status: err.response.status,
              body: {},
            };
          } else {
            this.$store.commit("setFeedbackSnack", {
              msg: this.$t("unexpectedError"),
              color: "error",
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
